export const cremlingCakes = {
  id: "cremlingCakes",
  link: "/#/recipes/recipes/cremlingCakes",
  name: "Cremling Cakes",
  cuisine: "Alethi",
  summary: "Cornbread muffins topped with coconut curry sauce and crayfish",
  inspiration: "Cornbread, Thai Yellow Curry",
  quantity: "6 muffins",
  time: "45 minutes",
  notes:
    "This recipe was a fun fusion of influences. The cake is a fairly standard American cornbread, just adapted to use the available ingredients. For the sauce, I chose to do the women's food version that was served to Shallan, and based it off Thai curry. I referred to Thai food for some Alethi women's food, since it's known for sweet curries. Finally, it's topped with a steamed crayfish, to take the place of the cremling.",
  quotes:
    "The small plates held crumbly cakes of Soulcast grain topped with a single steamed cremling—a variety known as a skrip, with a flat tail, two large claws, and  long  antennae... The only difference between Shallan’s meal and Wit’s was the sauce—hers sweet, his spicy. (Oathbringer ch 68)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/cremling-cake-overview.jpg",
  ingredientSections: [
    {
      title: "Cakes",
      ingredients: [
        {
          item: "corn",
          display: "1 cup cornmeal"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "honey",
          display: "2 tbsp honey"
        },
        {
          item: "vegetableOil",
          display: "2 tbsp vegetable oil"
        },
        {
          item: "water",
          display: "3/4 cup water"
        },
        {
          item: "eggs",
          display: "2 egg whites"
        }
      ]
    },
    {
      title: "Sauce",
      ingredients: [
        {
          item: "crayfish",
          display: "6 crayfish"
        },
        {
          item: "onion",
          display: "1/2 onion"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic, minced"
        },
        {
          item: "ginger",
          display: "1 inch ginger root"
        },
        {
          item: "coconut",
          display: "2 tbsp coconut oil"
        },
        {
          item: "curryPaste",
          display: "1 heaping tbsp yellow curry paste"
        },
        {
          item: "honey",
          display: "2 tsp honey"
        },
        {
          item: "coconut",
          display: "1 cup coconut milk"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "turmeric",
          display: "1/2 tsp ground turmeric"
        }
      ]
    }
  ],
  steps: [
    "Preheat oven to 400 degrees Fahrenheit. Grease 6 muffin cups in a muffin tin.",
    "In a medium bowl, combine cornmeal, 1/2 tsp salt, 2 tbsp honey, 2 tbsp oil, and water. Mix well. Some of the liquid may separate from the batter - that's ok.",
    "In a separate bowl, beat egg whites just past stiff peaks, until they're very stiff but liquid hasn't started separating out yet.",
    "Fold the egg whites into the batter just until combined. There will still be white bits visible.",
    "Gently spoon the batter into the six muffin cups, dividing it evenly. It should fill the cups. Bake 18-20 minutes or until cooked through and golden on top.",
    "Meanwhile, start steaming the crayfish. If raw, steam for 5-7 minutes until red. If precooked and frozen, follow the directions on the package.",
    "While the crayfish are steaming and the cakes are baking, make the sauce. Dice the onion, and peel and mince the garlic and ginger. Heat 2 tbsp oil in a pan, then add the onion, garlic, and ginger. Saute on medium high heat until the onion is transparent but not yet browned.",
    "Add curry paste. Cook and stir for 2 more minutes. Add 2 tsp honey, coconut milk, 1/2 tsp salt, and turmeric. Mix well, bring to a boil, and cook for 2 more minutes.",
    "Once the cakes are baked, let them cool for 5 minutes. Then remove them from the pan, and serve covered in curry sauce and topped with a crayfish."
  ]
}
